{{#if fullWidth}}
<div class="col-xs-12">
{{/if}}
	<div class="alert alert-{{type}}"><strong>{{text}}</strong>{{{additionalHtml}}}</div>
{{#if fullWidth}}
</div>
{{/if}}
